module.exports = __webpack_public_path__ + "static/media/megaphone.11e9a411.svg";